// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"e82e503f","479":"cddfcc9c","884":"490cc67c","933":"9b29c50b","962":"008f4c6f"}[chunkId] + ".chunk.js";
};